import { InputNumber, Typography, Spin, Form } from "antd";
import useElements from "../hooks/useElements";

const { Text } = Typography;

export default function EmissionRatesTab({ form }) {
  const { elements, loading } = useElements([], true);
  const rates = Form.useWatch("emissionRates", form) || [];

  const setRates = (updater) => {
    const next = typeof updater === "function" ? updater(rates) : updater;
    form.setFieldsValue({ emissionRates: next });
  };

  const handleRateChange = (elementId, value) => {
    setRates((prev) => {
      const existing = prev.find((r) => r.elementId === elementId);
      if (existing) {
        return prev.map((r) =>
          r.elementId === elementId
            ? { ...r, emissionRate: value }
            : r
        );
      }
      return [...prev, { elementId, emissionRate: value }];
    });
  };

  if (loading) return <Spin />;

  return (
    <div style={{ padding: 16 }}>
      {/* 🔑 REGISTRO DEL FIELD */}
      <Form.Item name="emissionRates" hidden>
        <input />
      </Form.Item>

      <Text type="secondary">
        Emission rates are expressed in kilograms per hour (kg/hr).
      </Text>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
          gap: 16,
          marginTop: 16,
        }}
      >
        {elements.map((el) => {
          const current = rates.find((r) => r.elementId === el.id);

          return (
            <div key={el.id} style={{ display: "flex", flexDirection: "column" }}>
              <Text strong>{el.name}</Text>

              <InputNumber
                min={0}
                step={0.01}
                placeholder="Optional"
                value={
                  typeof current?.emissionRate === "number"
                    ? current.emissionRate
                    : null
                }
                onChange={(val) => handleRateChange(el.id, val)}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
